import * as React from 'react';
import { VideoModel } from '../../Models/Video.interface';
import { InfoButton } from './InfoButton';
import { MyListButton } from './MyListButton';
import { PlayButton } from './PlayButton';
import "./Button.css";
import VideoManager from '../../Managers/VideoManager';

type VideoButtonGroupProps = {
    video?: VideoModel
    featured?:boolean
}

export const VideoButtonGroup = (props: VideoButtonGroupProps) => {
    const { video, featured } = props


    const onPlay  = () => {
        VideoManager.setVideo(video)
    }

    const onList = () => {
        console.log("on list")
    }

    const onInfo = () => {
        console.log("on info")
    }

    return(
        <>
        <div className="carousel-bottom-buttons mobile-hide">
            <PlayButton style={{marginRight: '1em'}} onClick={onPlay} featured/>
            <MyListButton onClick={onList} featured/>
            <InfoButton onClick={onInfo} featured/>
        </div>
         <div className={`carousel-bottom-buttons hide-above-mobile `}>
            <MyListButton  onClick={onList}   />
            <PlayButton  onClick={onPlay}  />                
            <InfoButton onClick={onInfo}  />
        </div>
        </>
    )
}